import Alert from "assets/AlertWarning";
import ThumsUp from "assets/ThumsUpOutlined";
import MetricsContent from "components/features/dashboard/MetricsContent";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { threshold } from "utils/CommonConstants";

export default function MetricDetails(props: any) {
  const { metric, metricsBar = true, sx = {}, isDashboard = false } = props;
  const metricValues = ["N/A", "NA", "-", "null", null];
  const { metricsValue: metricsValue1, metricName, timeFrameName, dateAsOf } = metric[0];
  const { metricName: metricName2 } = metric[1];
  const isValidMetricValue2 = !metricValues?.includes(metric[1]?.metricsValue?.toLowerCase());
  const metricsValue2 = isValidMetricValue2 ? metric[1]?.metricsValue : "";
  const showValue2 = isValidMetricValue2 && metric[1]?.displayOnDashBoard?.toLowerCase() === "yes";
  const colorHighlight1 = metric[0]?.colorHighlight;
  const colorHighlight2 = metric[1]?.colorHighlight;

  const getNumValue = (val1: any) => {
    const percentageValue: number = parseFloat(val1);
    return percentageValue;
  };

  const getColor = (cond1: any, cond2: any, label: string, showBg: boolean = false) => {
    const showIcon = metric[1]?.metricForImprovement?.toLowerCase() !== "text";
    if (cond1) {
      const colour = showBg ? tokens.Text.Feedback.SuccessDark : tokens.Text.Feedback.Success;
      return {
        color: colour,
        label: label,
        icon: showIcon ? <ThumsUp color={colour} /> : <></>,
        backGroundColor: "inherit",
        showBg: showBg
      };
    } else if (cond2) {
      const colour = showBg ? tokens.Text.Feedback.OverdueDark : tokens.Text.Feedback.Overdue;
      return {
        color: colour,
        label: label,
        icon: showIcon ? <Alert color={colour} width="16" height="16" /> : <></>,
        backGroundColor: "inherit",
        showBg: showBg
      };
    } else {
      const colour = tokens.Text.General.PrimaryHeadline;
      return {
        showBg: showBg,
        color: colour,
        label: label,
        backGroundColor: "inherit"
      };
    }
  };

  const getColorHighLight = (val: string) => {
    if (val?.toLowerCase() === "yes") return true;
    else return false;
  };
  const getColorConditionCheck = (cond1: boolean, cond2: boolean, showBg: boolean = true) => {
    const metricValue1 = metricsValue1;
    const metricValue2 = metricsValue2;

    let metricData: any = {
      metricsName: metricName,
      dateAsOf: dateAsOf,
      timeFrameName: timeFrameName,
      metricName2: metricName2
    };

    metricData = {
      ...metricData,
      metricScoreDetails: getColorHighLight(colorHighlight1)
        ? getColor(cond1, cond2, metricValue1)
        : getColor(false, false, metricValue1)
    };
    if (showValue2)
      metricData = {
        ...metricData,
        metricValue2: getColorHighLight(colorHighlight2)
          ? getColor(cond1, cond2, metricValue2, showBg)
          : getColor(false, false, metricValue2, showBg)
      };
    return metricData;
  };

  const getThresholdDetails = (val: string) => {
    const value = val?.toLowerCase();
    let chipDetails: any;
    let scoreColor: any;
    switch (value) {
      case threshold.Outstanding: {
        scoreColor = tokens.Text.Feedback.Done;
        chipDetails = { backGroundColor: colors.Green.Green50, color: tokens.Text.Feedback.Done, label: val };
        break;
      }
      case threshold.Acceptable: {
        scoreColor = tokens.Text.Feedback.Done;
        chipDetails = {
          backGroundColor: tokens.Background.General.Secondary,
          color: tokens.Text.General.Secondary,
          label: val
        };
        break;
      }
      case threshold.Unacceptable: {
        scoreColor = tokens.Text.Feedback.Alert;
        chipDetails = { backGroundColor: colors.Red.Red50, color: tokens.Text.Feedback.Alert, label: val };
        break;
      }

      default: {
        scoreColor = tokens.Text.General.PrimaryHeadline;
        chipDetails = { backGroundColor: "transparent", color: tokens.Text.General.PrimaryHeadline, label: val };
      }
    }
    return {
      metricScoreDetails: {
        label: metricsValue1,
        color: getColorHighLight(colorHighlight1) ? scoreColor : tokens.Text.General.PrimaryHeadline
      },
      chipDetails: showValue2 && chipDetails
    };
  };

  const getMetricsValues = () => {
    let metricData: any = {
      metricsName: metricName,
      dateAsOf: dateAsOf,
      timeFrameName: timeFrameName,
      metricName2: metricName2
    };

    if (metric[1]?.metricForImprovement === "Text") {
      const indicatorValue = metricsValue2?.toLowerCase();
      const positiveIndicator = indicatorValue?.includes("positive");
      const NegativeIndicator = indicatorValue?.includes("negative");
      if (positiveIndicator || NegativeIndicator) {
        return getColorConditionCheck(positiveIndicator, NegativeIndicator, false);
      } else {
        const updatedData = getThresholdDetails(metricsValue2);
        return {
          ...metricData,
          ...updatedData
        };
      }
    } else {
      metricData = { ...metricData, metricsValue2 };
      const val1 = getNumValue(metricsValue1);
      const val2 = getNumValue(metricsValue2);
      switch (metric[1]?.metricForImprovement) {
        case ">": {
          return getColorConditionCheck(val2 >= val1, val2 < val1);
        }
        case "<": {
          return getColorConditionCheck(val2 <= val1, val2 > val1);
        }
        case "+": {
          if (metric[0]?.metricForImprovement === "+") {
            return getColorConditionCheck(val1 >= 0, val1 < 0);
          } else {
            return getColorConditionCheck(val2 >= 0, val2 < 0);
          }
        }
        case "-": {
          if (metric[0]?.metricForImprovement === "-") {
            return getColorConditionCheck(val1 <= 0, val1 > 0);
          } else {
            return getColorConditionCheck(val2 <= 0, val2 > 0);
          }
        }
        default: {
          return {
            ...metricData,
            metricScoreDetails: getColor(false, false, metricsValue1)
          };
        }
      }
    }
  };
  return (
    <>
      {metric?.length > 1 ? (
        <MetricsContent
          metricDetails={getMetricsValues()}
          metricsBar={metricsBar}
          sx={sx}
          isDashboard={isDashboard}
          showValue2={showValue2}
        />
      ) : (
        <MetricsContent
          metricsBar={metricsBar}
          sx={sx}
          metricDetails={{
            metricsName: metricName,
            metricScoreDetails: { label: metricsValue1 },
            timeFrameName: timeFrameName,
            dateAsOf: dateAsOf,
            metricName2: metricName2
          }}
          isDashboard={isDashboard}
          showValue2={showValue2}
        />
      )}
    </>
  );
}
